import { z } from 'zod';
import { passwordPolicySchema } from './passwordPolicy';

/**
 * Validation for the auth forms.
 *
 * Messages are reproduced VERBATIM from the Angular templates so QA diffing the two
 * apps sees identical text:
 *   - login.component.html:27  "Email is required"
 *   - login.component.html:30  "Please enter a valid email address"
 *   - login.component.html:42  "Password is required"
 */
export const loginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  password: z.string().min(1, 'Password is required'),
  /** Real, unlike the Angular checkbox which had no formControlName at all. */
  rememberMe: z.boolean(),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

export const forgotEmailSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
});
export type ForgotEmailValues = z.infer<typeof forgotEmailSchema>;

export const otpSchema = z.object({
  otp: z.string().min(1, 'OTP is required'),
});
export type OtpValues = z.infer<typeof otpSchema>;

/**
 * `passwordMatchValidator` from forgot-password.component.ts, as a cross-field refine.
 *
 * The Angular version was a group-level validator returning `{ passwordMismatch: true }`.
 * `.refine` with an explicit `path` puts the message on `confirmPassword`, which is
 * where the template rendered it.
 */
export const newPasswordSchema = z
  .object({
    newPassword: passwordPolicySchema,
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((values) => values.newPassword === values.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type NewPasswordValues = z.infer<typeof newPasswordSchema>;
